export const maxDecimalPlacesForWeight = 1;

export const maxValueForWeight = 999_999_999;
export const minValueForWeight = 0;
